import { CORE_TYPES } from '@/engine/app/modules/core';
import type { CommandHistory } from '@/engine/app/modules/core/services/CommandHistory';
import type { CommandProcessor } from '@/engine/app/modules/core/services/CommandProcessor';
import { inject, injectable } from 'inversify';

const tooltips = {
  mac: {
    undo: 'Undo (Cmd+Z)',
    redo: 'Redo (Cmd+Shift+Z)'
  },
  other: {
    undo: 'Undo (Ctrl+Z)',
    redo: 'Redo (Ctrl+Y)'
  }
};

@injectable()
export class UndoRedoButtonsController {
  private readonly _commandHistory: CommandHistory;

  private readonly _commandProcessor: CommandProcessor;

  private readonly _tooltips = navigator.platform.includes('Mac') ? tooltips.mac : tooltips.other;

  public constructor(
    @inject(CORE_TYPES.CommandHistory) commandHistory: CommandHistory,
    @inject(CORE_TYPES.CommandProcessor) commandProcessor: CommandProcessor
  ) {
    this._commandHistory = commandHistory;
    this._commandProcessor = commandProcessor;
  }

  public get canUndo(): boolean {
    return this._commandHistory.canUndo();
  }

  public get canRedo(): boolean {
    return this._commandHistory.canRedo();
  }

  public undo(): void {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
    this._commandProcessor.undo();
  }

  public redo(): void {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
    this._commandProcessor.redo();
  }

  public get undoTooltip(): string {
    return this._tooltips.undo;
  }

  public get redoTooltip(): string {
    return this._tooltips.redo;
  }
}
